import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import VolumeStore from '../stores/volume_store';

const styles = StyleSheet.create({
  volumeSelect: {
    paddingLeft: '1em',
    width: '20em',
    height: '2em',
    color: 'black',
    fontSize: '1.3em',
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    borderRadius: '0.3em',
  },
});

type Props = {
  style?: any;
  excludeList?: any;
  device?: any;
  user?: any;
  onlyProject?: boolean;
  onlyMedia?: boolean;
  onlyOrgId?: number;
  excludeDisabled?: boolean;
  value: any;
  onChange: any;
};
type State = {
  volume_list: any;
};

export default class VolumeSelect extends React.PureComponent<Props, State> {
  state = {
    volume_list: null,
  };
  componentDidMount() {
    VolumeStore.addChangeListener(this._onVolumeUpdate);
    VolumeStore.fetch();
    this._onVolumeUpdate();
  }
  componentWillUnmount() {
    VolumeStore.removeChangeListener(this._onVolumeUpdate);
  }
  _onVolumeUpdate = () => {
    const volume_list = VolumeStore.getList();
    this.setState({ volume_list });
  };
  _onManage = (user_id) => {
    this.props.history.push('/admin/user/' + user_id);
  };

  render() {
    const {
      style,
      excludeList,
      device,
      user,
      onlyProject,
      onlyMedia,
      onlyOrgId,
      excludeDisabled,
      value,
      onChange,
    } = this.props;
    const { volume_list } = this.state;

    let content = null;
    if (!volume_list) {
      content = <ProgressSpinner />;
    } else {
      const valid_list = volume_list.filter((volume) => {
        const { volume_id, org_id } = volume;
        let ret = true;
        if (excludeList) {
          const excluded = excludeList.find((v) => v.volume_id === volume_id);
          if (excluded) {
            ret = false;
          }
        }
        if (user) {
          const found = user.org_list.find((o) => o.org_id === org_id);
          if (!found) {
            ret = false;
          }
        }
        if (onlyOrgId && org_id !== onlyOrgId) {
          ret = false;
        }
        if (onlyProject && volume.is_media_volume) {
          ret = false;
        }
        if (onlyMedia && !volume.is_media_volume) {
          ret = false;
        }
        if (excludeDisabled && volume.is_disabled) {
          ret = false;
        }
        return ret;
      });
      const org_id = (device && device.org_id) || (user && user.org_id);
      valid_list.sort(_sortOrg.bind(null, org_id));

      const options = [
        { value: 0, text: '' },
        ...valid_list.map((v) => ({
          value: v.volume_id,
          text: v.volume_name,
        })),
      ];

      content = (
        <Select
          style={[styles.volumeSelect, style]}
          options={options}
          value={value}
          onChange={onChange}
        />
      );
    }
    return content;
  }
}

function _sortVolume(a, b) {
  if (a.org_id === b.org_id) {
    return a.volume_name.localeCompare(b.volume_id);
  } else {
    return a.org_id - b.org_id;
  }
}

function _sortOrg(org_id, a, b) {
  if (org_id === a.org_id && org_id === b.org_id) {
    return _sortVolume(a, b);
  } else if (org_id === a.org_id) {
    return -1;
  } else if (org_id === b.org_id) {
    return 1;
  } else {
    return _sortVolume(a, b);
  }
}
